/* global ExportURL */

import {useCallback} from 'react';
import {connect} from 'react-redux';

import _, {interpolate} from 'topmeteo/utils/i18n';

import BaseTab from './BaseTab';
import NameInput from './NameInput';
import {useSetNotification} from './Notification';
import NotAvailable from './NotAvailable';

const ButtonLabel = _('Export');
const SuccessMessage = _('Your task %(name)s has been exported.');

const ExportTab = ({regionID, ...props}) => (
    <BaseTab {...props} action={ExportURL} buttonLabel={ButtonLabel}>
        <input type="hidden" name="region" value={regionID} />
        <NameInput />
    </BaseTab>
);

const ExportTabWrapper = ({isAnonymous, ...props}) => {
    const setNotification = useSetNotification();
    const handleSuccess = useCallback(
        result => {
            const message = interpolate(SuccessMessage, result);

            return setNotification(message);
        },
        [setNotification],
    );

    return isAnonymous ? <NotAvailable {...props} /> : <ExportTab {...props} onSuccess={handleSuccess} />;
};

const mapStateToProps = ({isAnonymous, regionID}) => ({isAnonymous, regionID});

export default connect(mapStateToProps)(ExportTabWrapper);
